const sortOptions = [
  { name: 'recommended', field: 'recommended', direction: 'desc' },
  { name: 'ascendingPrice', field: 'price', direction: 'asc' },
  { name: 'descendingPrice', field: 'price', direction: 'desc' },
  { name: 'alphabeticalDown', field: 'name', direction: 'asc' },
  { name: 'alphabeticalUp', field: 'name', direction: 'desc' },
]

export default sortOptions
